import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useState, useRef, useEffect } from "react";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import Paper from "@mui/material/Paper";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  GENDER_DETAILS,
  GST_PERCENTAGE,
  MINIMUM_PREMIUM_AMOUNT,
  NOMINEE_RELATIONSHIP_DETAILS,
  BRISK_NOMINEE_RELATIONSHIP_DETAILS,
  PAYMENT_DETAILS,
  POLICY_TYPE_DETAILS,
  PREMIUM_PERCENTAGE,
} from "../../Shared/CommonConstant";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "antd";
import { LocalizationProvider } from "@mui/x-date-pickers";
import {
  briskMakeList,
  briskModelList,
  getCutPayDetailsByUserId,
  getBriskWalletAmount,
  createBriskCertificate,
  briskPlanList,
  saveBriskCertificate,
  formatCurrency,
} from "../../Service/girnarApi";
import Loader from "../../UiComponents/Loader/Loader";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import swal from "sweetalert";
import { AccountBalanceWalletIcon } from "../../Resources/Icons/icons";
import { Button, IconButton, Tooltip } from "@mui/material";
import { RefreshOutlined } from "@mui/icons-material";
import dayjs from "dayjs";

const initialValues = {
  totalPremium: "",
  CustomerName: "",
  MobileNo: "",
  EmailID: "",
  City: "",
  State: "",
  CustomerGender: "",
  CustomerDOB: "",
  NomineeName: "",
  NomineeGender: "",
  Relation: "",
  Make: "",
  Model: "",
  EngineNo: "",
  ChassisNo: "",
  RegistrationNo: "",
  PaymentMode: PAYMENT_DETAILS[0].value,
  policyType: POLICY_TYPE_DETAILS[0].value,
  totalPremium: "",
  netPremium: "",
  gst: "0",
  minimumPremium: 0,
  Address_Line1: "",
  Address_Line2: "",
  PlanName: "",
};

// const resetForm = () => {
//   Object.entries(initialValues).forEach(([key, value]) => {
//     // console.log(`Key: ${key}, Value: ${value}`);
//     setFieldValue(key, value);
//   });
// };

const BriskCreateCertificate = (prop) => {
  let formRef = useRef();
  const [openLoader, setOpenLoader] = useState(false);
  const [walletAmount, setWalletAmount] = useState("");
  const [walletBalance, setWalletBalance] = useState("");
  const UserType = sessionStorage.getItem("userType");
  const [isSaveAction, setIsSaveAction] = useState(false);
  let POLICY_TYPE = POLICY_TYPE_DETAILS;
  const { selectedData, isEdit } = prop;
  const [fillDOB, setFillDOB] = useState(null);
  const [minimumPremium, setMinimumPremium] = useState(MINIMUM_PREMIUM_AMOUNT);
  const [MODEL_LIST, setModelList] = useState([]);
  const [PLAN_LIST, setPlanList] = useState([]);
  const [MAKE_LIST, setMakeList] = useState([]);

  if (UserType != "CLIENT") {
    POLICY_TYPE = POLICY_TYPE.slice(0, 1);
  }
  const initialLoad = async () => {
    const makeList = await briskMakeList();
    console.log("makeList ", makeList.data.data);
    const data = makeList.data.data;
    const makeArray = data.map((e) => {
      return { label: e, value: e };
    });
    console.log("makeArray ", makeArray);
    setMakeList(makeArray || []);
  };

  const CreateCertificateSchema = Yup.object().shape({
    totalPremium: Yup.number()
      .min(minimumPremium, `Total premium must be at least ${minimumPremium}`)
      .required("Total Premium Required"),
    CustomerName: Yup.string().required("Customer Name Required"),
    Address_Line1: Yup.string().required("Address Line 1 Required"),
    Address_Line2: Yup.string().required("Address Line 2 Required"),
    MobileNo: Yup.string().required("Mobile Required"),
    EmailID: Yup.string().required("Email Required"),
    City: Yup.string().required("City Required"),
    State: Yup.string().required("State Required"),
    CustomerGender: Yup.string().required("Gender Required"),
    CustomerDOB: Yup.string().required("Date of Birth Required"),
    NomineeName: Yup.string().required("Nominee Name Required"),
    NomineeGender: Yup.string().required("Nominee Gender Required"),
    Relation: Yup.string().required("Nominee Relationship Required"),
    Make: Yup.string().required("Make Required"),
    PlanName: Yup.string().required("Plan Name Required"),
    Model: Yup.string().required("Model Required"),
    EngineNo: Yup.string().required("Engine Number Required"),
    ChassisNo: Yup.string().required("Chassis Number Required"),
    RegistrationNo: Yup.string().required("Registration Number Required"),
    PaymentMode: Yup.string().required("Payment Mode Required"),
    policyType: Yup.string().required("Policy Type Required"),
  });

  const getModel = async (make) => {
    const modelList = await briskModelList(make);
    console.log("modelList ", modelList?.data?.data);
    const data = modelList?.data?.data || [];
    const modelArray = data.map((e) => {
      return { label: e, value: e };
    });
    setModelList(modelArray || []);
    console.log("MODEL_LIST ", MODEL_LIST);
  };

  const getPlan = async () => {
    const planList = await briskPlanList();
    console.log("planList ", planList?.data?.data);
    const data = planList?.data?.data || [];
    const planArray = data.map((e) => {
      return { label: e?.PlanName, value: e?.PlanName, price: e?.TotalPrice };
    });
    setPlanList(planArray || []);
    console.log("PLAN_LIST ", PLAN_LIST);
  };

  useEffect(() => {
    initialLoad();
    getPlan();
  }, []);

  const save = async (data) => {
    console.log("data :::::", data, "isSaveAction :::::", isSaveAction);
    // return true;
    let tempWalletAmount = 0;
    setOpenLoader(true);
    await getBriskWalletAmount().then((res) => {
      setWalletBalance(res?.data?.balance || 0);
      tempWalletAmount = res?.data?.balance || 0;
    });
    // data.docid = selectedData?._id || "";
    console.log("tempWalletAmount ", tempWalletAmount);
    console.log("data.totalPremium ", data.totalPremium);
    if (!isSaveAction && Number(data.totalPremium) > tempWalletAmount) {
      ToastError("Insufficient wallet balance");
      // const topupAmount = data.policyPremium - tempWalletAmount;
      // if (topupAmount) {
      //   setOpenLoader(true);
      //   addWalletAmount({ amount: Number(topupAmount) })
      //     .then((res) => {
      //       console.log("res :::", res.data);
      //       window.open(res?.data?.redirectUrl, "_blank");
      //     })
      //     .catch((err) => {
      //       ToastError(err?.response?.data?.message || "Something went wrong");
      //     })
      //     .finally(() => setOpenLoader(false));
      // }
      setOpenLoader(false);
      return true;
    }
    const response = isSaveAction
      ? await saveBriskCertificate(data)
        .then((res) => {
          swal(res?.message);
        })
        .catch((err) => {
          ToastError(err?.response?.data?.message || "Something went wrong");
          return true;
        })
        .finally(() => {
          setOpenLoader(false);
        })
      : await createBriskCertificate(data)
        .then((res) => {
          console.log("res :::", res.data);

          swal(
            "Certicate Created successfully, Are you want to download certificate!",
            {
              buttons: {
                defeat: {
                  text: "Download",
                },
              },
            },
          ).then((value) => {
            switch (value) {
              case "defeat":
                window.open(res?.data?.downloadUrl, "_blank");
                // resetForm();
                break;
            }
          });
          getBriskWalletAmount();
        })
        .catch((err) => {
          ToastError(err?.response?.data?.message || "Something went wrong");
          return true;
        })
        .finally(() => {
          setOpenLoader(false);
        });
    return response;
  };

  const handleChange = (e) => {
    setWalletAmount(e.target.value);
  };

  const calculateCutPay = (e) => {
    const totalPrem = e.target.value;
    // console.log("totalPrem ", totalPrem);
    if (minimumPremium) {
      const netPremium = (totalPrem * 100) / PREMIUM_PERCENTAGE.toFixed(2);
      const gstValue = (netPremium * GST_PERCENTAGE) / 100;
      const premium = minimumPremium + gstValue;
      // console.log("netPremium  ", netPremium);
      // console.log("gstValue  ", gstValue);
      // console.log("premium  ", Math.round(premium));
      formRef.setFieldValue("totalPremium", Math.round(premium));
      formRef.setFieldValue("netPremium", netPremium.toFixed(2));
      formRef.setFieldValue("gst", gstValue.toFixed(2));
    } else {
      formRef.setFieldValue("totalPremium", totalPrem);
    }
    formRef.setFieldValue("totalPremium", totalPrem);
  };

  useEffect(() => {
    // getWallet();
    //console.log("selectedData : ", selectedData);
    if (selectedData) {
      const daysjsDate = dayjs(
        selectedData?.payload?.CustomerDOB,
        "DD-MM-YYYY",
      );
      setFillDOB(daysjsDate);
      //console.log("dayjs ", dayjs(selectedData?.payload?.CustomerDOB));
      formRef.setFieldValue("totalPremium", selectedData.totalPremium);
      formRef.setFieldValue(
        "CustomerName",
        selectedData?.payload?.CustomerName,
      );
      formRef.setFieldValue(
        "Address_Line1",
        selectedData?.payload?.Address_Line1,
      );
      formRef.setFieldValue(
        "Address_Line2",
        selectedData?.payload?.Address_Line2,
      );
      formRef.setFieldValue("MobileNo", selectedData?.payload?.MobileNo);
      formRef.setFieldValue("EmailID", selectedData?.payload?.EmailID);
      formRef.setFieldValue("City", selectedData?.payload?.City);
      formRef.setFieldValue("State", selectedData?.payload?.State);
      formRef.setFieldValue(
        "CustomerGender",
        selectedData?.payload?.CustomerGender,
      );
      formRef.setFieldValue("CustomerDOB", daysjsDate.$d);
      formRef.setFieldValue("PlanName", selectedData?.payload?.PlanName);
      formRef.setFieldValue("NomineeName", selectedData?.payload?.NomineeName);
      formRef.setFieldValue(
        "NomineeGender",
        selectedData?.payload?.NomineeGender,
      );
      formRef.setFieldValue("Relation", selectedData?.payload?.Relation);
      formRef.setFieldValue("Make", selectedData?.payload?.Make);
      formRef.setFieldValue("Model", selectedData?.payload?.Model);
      formRef.setFieldValue("EngineNo", selectedData?.payload?.EngineNo);
      formRef.setFieldValue("ChassisNo", selectedData?.payload?.ChassisNo);
      formRef.setFieldValue(
        "RegistrationNo",
        selectedData?.payload?.RegistrationNo,
      );
      formRef.setFieldValue("PaymentMode", selectedData?.payload?.PaymentMode);
      formRef.setFieldValue("policyType", selectedData?.policyType);
      formRef.setFieldValue("policyPremium", selectedData?.policyPremium);
      formRef.setFieldValue("netPremium", selectedData?.netPremium);
      formRef.setFieldValue("gst", selectedData?.gst);
    }
    getCutPayDetailsByUserId().then((res) => {
      // console.log("cut pay response ", res);
      const isCutPay = res.data?.isCutPay || false;
      const minimumPrem = res.data?.minimumPremium || 0;
      if (isCutPay) {
        setMinimumPremium(minimumPrem);
        formRef.setFieldValue("minimumPremium", minimumPremium);
      }
      // console.log("minimumPrem ", minimumPrem);
      // console.log("isCutPay ", isCutPay);
      // console.log("minimumPremium ", minimumPremium);
    });
  }, [minimumPremium]);

  const getWallet = () => {
    setOpenLoader(true);
    getBriskWalletAmount()
      .then((res) => {
        setWalletBalance(res?.data?.balance || 0);
      })
      .catch((err) => {
        ToastError(err?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  return (
    <>
      <Box
        sx={{ flexGrow: 1 }}
        style={{
          "margin-top": isEdit ? "140px" : "0px",
          "padding-left": isEdit ? "10px" : "0px",
        }}
      >
        <Grid container className="Master_Header_Container">
          <Grid item xs={12} sm={3}>
            <Typography className="Master_Header_Heading">
              Brisk Create Certificate
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9} />
        </Grid>
      </Box>
      <Paper sx={{ padding: "10px 0 0 0", margin: "0 4px 20px 12px" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={CreateCertificateSchema}
          innerRef={(ref) => {
            if (ref) {
              formRef = ref;
            }
          }}
          onSubmit={async (values, { resetForm }) => {
            const response = await save(values);
            if (!response) {
              resetForm();
            }
          }}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <Form>
              <Typography sx={{ ml: 2 }}>Customer Details</Typography>
              <Grid container sx={{ p: 2 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Customer Name"
                    value={values?.CustomerName}
                    important="*"
                  >
                    <Field
                      className="textField w-100"
                      onChange={(e) =>
                        setFieldValue(
                          "CustomerName",
                          e.target.value.toUpperCase(),
                        )
                      }
                      name="CustomerName"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.CustomerName && touched.CustomerName ? (
                        <div>{errors.CustomerName}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <FloatLabel
                      label="Date of birth"
                      value="Reactjs"
                      important="*"
                    >
                      <DatePicker
                        name="CustomerDOB"
                        className="Date_Picker w-100"
                        placeholder="Select Date or Enter DD/MM/YYYY"
                        value={fillDOB}
                        onChange={(e) => {
                          setFieldValue("CustomerDOB", e?.$d);
                          // console.log("date ::: ", e.$d);
                          setFillDOB(e);
                        }}
                        // key={refreshCount}
                        format={"DD/MM/YYYY"}
                        placement="bottomRight"
                      />
                    </FloatLabel>
                  </LocalizationProvider>
                  <div className="errorMessage mb-2 mt-2">
                    {errors.CustomerDOB && touched.CustomerDOB ? (
                      <div>{errors.CustomerDOB}</div>
                    ) : (
                      " "
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Gender"
                    value={values.CustomerGender}
                    important="*"
                  >
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={GENDER_DETAILS}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value
                      }
                      clearIcon={false}
                      value={values.CustomerGender}
                      name="Gender"
                      onChange={(option, value) => {
                        setFieldValue("CustomerGender", value?.label);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.CustomerGender && touched.CustomerGender ? (
                        <div>{errors.CustomerGender}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Mobile"
                    value={values?.MobileNo}
                    important="*"
                  >
                    <Field className="textField w-100" name="MobileNo" />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.MobileNo && touched.MobileNo ? (
                        <div>{errors.MobileNo}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Email"
                    value={values?.EmailID}
                    important="*"
                  >
                    <Field className="textField w-100" name="EmailID" />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.EmailID && touched.EmailID ? (
                        <div>{errors.EmailID}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}></Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Address Line 1"
                    value={values?.Address_Line1}
                    important="*"
                  >
                    <Field
                      className="textField w-100"
                      onChange={(e) =>
                        setFieldValue(
                          "Address_Line1",
                          e.target.value.toUpperCase(),
                        )
                      }
                      name="Address_Line1"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.Address_Line1 && touched.Address_Line1 ? (
                        <div>{errors.Address_Line1}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Address Line 2"
                    value={values?.Address_Line2}
                    important="*"
                  >
                    <Field
                      className="textField w-100"
                      onChange={(e) =>
                        setFieldValue(
                          "Address_Line2",
                          e.target.value.toUpperCase(),
                        )
                      }
                      name="Address_Line2"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.Address_Line2 && touched.Address_Line2 ? (
                        <div>{errors.Address_Line2}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}></Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel label="City" value={values?.City} important="*">
                    <Field
                      className="textField w-100"
                      onChange={(e) =>
                        setFieldValue("City", e.target.value.toUpperCase())
                      }
                      name="City"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.City && touched.City ? (
                        <div>{errors.City}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel label="State" value={values?.State} important="*">
                    <Field
                      className="textField w-100"
                      onChange={(e) =>
                        setFieldValue("State", e.target.value.toUpperCase())
                      }
                      name="State"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.State && touched.State ? (
                        <div>{errors.State}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
              </Grid>
              <hr />
              <Typography sx={{ ml: 2 }}>Nominee Details</Typography>
              <Grid container sx={{ p: 2 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Nominee Name"
                    value={values?.NomineeName}
                    important="*"
                  >
                    <Field
                      className="textField w-100"
                      onChange={(e) =>
                        setFieldValue(
                          "NomineeName",
                          e.target.value.toUpperCase(),
                        )
                      }
                      name="NomineeName"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.NomineeName && touched.NomineeName ? (
                        <div>{errors.NomineeName}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Nominee Gender"
                    value={values.NomineeGender}
                    important="*"
                  >
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={GENDER_DETAILS}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value
                      }
                      clearIcon={false}
                      value={values.NomineeGender}
                      name="NomineeGender"
                      onChange={(option, value) => {
                        setFieldValue("NomineeGender", value?.label);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.NomineeGender && touched.NomineeGender ? (
                        <div>{errors.NomineeGender}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Nominee Relationship"
                    value={values.Relation}
                    important="*"
                  >
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={BRISK_NOMINEE_RELATIONSHIP_DETAILS}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value
                      }
                      clearIcon={false}
                      value={values.Relation}
                      name="nomineeRelationShip"
                      onChange={(option, value) => {
                        setFieldValue("Relation", value?.label);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.Relation && touched.Relation ? (
                        <div>{errors.Relation}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
              </Grid>
              <hr />
              <Typography sx={{ ml: 2 }}>Vehicle Details</Typography>
              <Grid container sx={{ p: 2 }} columnSpacing={2}>
                <Grid item xs={12} sm={4}>
                  <FloatLabel label="Make" value={values.Make} important="*">
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={MAKE_LIST}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value
                      }
                      clearIcon={false}
                      value={values.Make}
                      name="make"
                      onChange={(event, value) => {
                        setFieldValue("Make", value?.label);
                        getModel(value?.label);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.Make && touched.Make ? (
                        <div>{errors.Make}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel label="Model" value={values.Model} important="*">
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={MODEL_LIST}
                      isOptionEqualToValue={(option, value) => {
                        return option?.value === value;
                      }}
                      clearIcon={false}
                      value={values.Model}
                      name="model"
                      onChange={(option, value) => {
                        setFieldValue("Model", value?.label);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.Model && touched.Model ? (
                        <div>{errors.Model}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}></Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Registration Number"
                    value={values.RegistrationNo}
                    important="*"
                  >
                    <Field
                      name="RegistrationNo"
                      type="text"
                      className="textField w-100"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.RegistrationNo && touched.RegistrationNo ? (
                        <div>{errors.RegistrationNo}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Chassis Number"
                    value={values.ChassisNo}
                    important="*"
                  >
                    <Field
                      name="ChassisNo"
                      type="text"
                      className="textField w-100"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.ChassisNo && touched.ChassisNo ? (
                        <div>{errors.ChassisNo}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Engine Number"
                    value={values.EngineNo}
                    important="*"
                  >
                    <Field
                      name="EngineNo"
                      type="text"
                      className="textField w-100"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.EngineNo && touched.EngineNo ? (
                        <div>{errors.EngineNo}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
              </Grid>
              <hr />
              <Typography sx={{ ml: 2 }}>Premium Details</Typography>
              <Grid container sx={{ p: 2 }} columnSpacing={2}>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Policy Type"
                    value={values.policyType}
                    important="*"
                  >
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={POLICY_TYPE}
                      clearIcon={false}
                      value={values.policyType}
                      name="policyType"
                      onChange={(option, value) => {
                        setFieldValue("policyType", value?.label);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value
                      } // Custom comparison
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.policyType && touched.policyType ? (
                        <div>{errors.policyType}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Select Plan"
                    value={values.PlanName}
                    important="*"
                  >
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={PLAN_LIST}
                      isOptionEqualToValue={(option, value) => {
                        return option?.value === value;
                      }}
                      clearIcon={false}
                      value={values.PlanName}
                      name="PlanName"
                      onChange={(option, value) => {
                        setFieldValue("PlanName", value?.label);
                        setFieldValue("totalPremium", value?.price);
                        // setFieldValue("policyPremium", value?.price);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.PlanName && touched.PlanName ? (
                        <div>{errors.PlanName}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Total Premium"
                    value={values.totalPremium}
                    important="*"
                  >
                    <Field
                      name="totalPremium"
                      type="number"
                      onChange={calculateCutPay}
                      className="textField w-100"
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.totalPremium && touched.totalPremium ? (
                        <div>{errors.totalPremium}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                // style={{ display: minimumPremium ? "block" : "none" }}
                >
                  <FloatLabel
                    label="Net Premium"
                    value={values.netPremium}
                    important="*"
                  >
                    <Field
                      name="netPremium"
                      type="number"
                      className="textField w-100"
                      readOnly
                    />
                    {minimumPremium && (
                      <small
                        style={{
                          color: "blue",
                          display: minimumPremium ? "block" : "none",
                        }}
                      >
                        {/* Minimum Premium: {minimumPremium},  */}
                        Net Premium: {values.netPremium}, GST: {values.gst}
                      </small>
                    )}
                    <div className="errorMessage mb-2 mt-2">
                      {errors.netPremium && touched.netPremium ? (
                        <div>{errors.netPremium}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FloatLabel
                    label="Payment Mode"
                    value={values.PaymentMode}
                    important="*"
                  >
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      options={PAYMENT_DETAILS}
                      // getOptionLabel={(option) => {
                      //   console.log("getOptionLabel ::", option);
                      //   return option.label || "";
                      // }}
                      clearIcon={false}
                      value={values.PaymentMode}
                      name="PaymentMode"
                      onChange={(option, value) => {
                        setFieldValue("PaymentMode", value?.value);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value
                      } // Custom comparison
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <div className="errorMessage mb-2 mt-2">
                      {errors.PaymentMode && touched.PaymentMode ? (
                        <div>{errors.PaymentMode}</div>
                      ) : (
                        " "
                      )}
                    </div>
                  </FloatLabel>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Button
                    className="Master_Header_create_Button Common_Button w-100"
                    startIcon={<AccountBalanceWalletIcon />}
                  >
                    Wallet Balance = {formatCurrency(walletBalance)}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Tooltip title="Refresh Wallet Balance">
                    <IconButton
                      onClick={getWallet}
                      color="primary"
                      aria-label="refresh"
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
              <hr />
              {/* <Typography sx={{ ml: 2 }}>Wallet Details</Typography>
              <Grid container sx={{ p: 2 }} columnSpacing={2}>
                <Grid item xs={12} sm={4}>
                  <FloatLabel label="Wallet Amount" value={walletAmount}>
                    <Field
                      name="walletAmount"
                      type="number"
                      value={walletAmount}
                      onChange={handleChange}
                      className="textField w-100"
                    />
                  </FloatLabel>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <button
                    className="w-100 Common_Button"
                    type="button"
                    onClick={() => addWallet(walletAmount)}
                  >
                    Wallet Topup
                  </button>
                </Grid>
              </Grid> */}
              <Grid container columnSpacing={2} sx={{ p: 2 }}>
                <Grid
                  style={{ display: isEdit ? "none" : "block" }}
                  item
                  xs={12}
                  sm={2}
                >
                  <button
                    onClick={() => setIsSaveAction(true)}
                    className="w-100 Common_Button"
                    type="submit"
                  >
                    Save
                  </button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <button
                    onClick={() => setIsSaveAction(false)}
                    className="w-100 Common_Button"
                    type="submit"
                  >
                    Create Certificate
                  </button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Paper>
      <Loader open={openLoader} />
    </>
  );
};

export default BriskCreateCertificate;
